import type { ComponentType, ReactNode } from "react";

export type ShellIcon = ComponentType<{ className?: string; "aria-hidden"?: boolean | "true" | "false" }>;

export interface ShellNavItem {
    to: string;
    label: string;
    icon: ShellIcon;
    count?: number;
}

export interface ShellFocusArea {
    id: string;
    label: string;
    description?: string;
    icon: ShellIcon;
    action?: ShellNavItem & { state?: unknown };
    items: readonly ShellNavItem[];
}

export interface ShellContextTab {
    id: string;
    label: string;
    content: ReactNode;
}

/**
 * Router-agnostic link. The shell never imports a router; pass a component
 * that wraps yours (react-router's NavLink, TanStack's Link, …). Without one,
 * links render as plain anchors, which is right for multi-page apps.
 */
export interface ShellLinkProps {
    to: string;
    state?: unknown;
    className: string;
    "aria-current"?: "page";
    onClick?: () => void;
    children: ReactNode;
}
export type ShellLink = ComponentType<ShellLinkProps>;

export function AnchorLink({ to, state: _state, children, ...props }: ShellLinkProps) {
    return <a href={to} {...props}>{children}</a>;
}

/** Same rule react-router's NavLink uses for a non-`end` match. */
export function isPathActive(pathname: string, to: string) {
    return pathname === to || pathname.startsWith(`${to}/`);
}
